export default {
    persona: {
        apellido: '',
        nombre: '',
        tipo_documento: '',
        nro_documento: '',
    },
    domicilio: '',
    email: '',
    telefono: '',
    menor: 0,
    querellante: 0,
    defensoria: '',
    particular: []
}